import {Injectable} from '@angular/core';

import {Rest, RestResponseSuccess} from '../../common/server-actions/rest';
import {WsEntitiesService} from '../../common/services/communication/ws-entities.service';


@Injectable({providedIn: 'root'})
export class ActiveDirectoriesRestService extends Rest {

    constructor(public wsEntitiesService: WsEntitiesService) {
        super({url: 'callsMonitor/activeDirectories'});
    }

    public getHashedActiveDirectoriesByIds = (listOfIds) => this.wsEntitiesService.getEntitiesArray('ads', listOfIds);

    public getActiveDirectories = (success?, failure?, parameters?) => {
        return this.get({parameters, extendParameters: true, skipPopulateFilter: true, requestAPI: 'ALL'}).then(success).catch(failure);
    };

    public getActiveDirectoriesByIds = (success, failure, parameters) => {
        this.get({parameters, extendParameters: true, skipPopulateFilter: true, requestAPI: 'IDS'}).then(success).catch(failure);
    };

    public getActiveDirectoryById = (success, failure, id) => {
        this.getById({success, failure, id, skipPopulateFilter: true, requestAPI: 'ID'});
    };

    public syncActiveDirectory = (success, id) => {
        this.add(success, ()=>{}, {activeDirectories: [id]}, 'callsMonitor/activeDirectories/actions/syncUsers');
    };

    protected handleSuccess = (requestAPI, response) => {
        const defaultObject = {data: {activeDirectories: [], pages: {total: 0, totalElements: 0}}};
        return response.status === 204 ? defaultObject : response;
    };

}
